import OspreySendRecepients from './template-send-email'

export default class TestMessage {

    send(dataKey) {
        return new OspreySendRecepients(dataKey)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/test-message/index.js